import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase.js";
import { Shell, Brand, ErrorText, Label } from "./common.jsx";

export function ResetPassword() {
  const [ready, setReady] = useState(false);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => { if (data.session) setReady(true); });
    const { data: sub } = supabase.auth.onAuthStateChange((event, s) => { if (s) setReady(true); });
    return () => sub.subscription.unsubscribe();
  }, []);

  const save = async e => {
    e.preventDefault();
    if (pw.length < 8) { setErr("Use at least 8 characters."); return; }
    if (pw !== pw2) { setErr("The two passwords don't match."); return; }
    setBusy(true); setErr("");
    const { error } = await supabase.auth.updateUser({ password: pw });
    setBusy(false);
    if (error) setErr(error.message); else location.href = "/";
  };

  return (
    <Shell>
      <div>
        <Brand sub="Choose a new password" />
        <h1 className="display" style={{ fontSize: 38, margin: "10px 0 0" }}>A fresh page.</h1>
      </div>
      {!ready ? (
        <div style={{ fontSize: 17, lineHeight: 1.6 }}>Open this page from the reset link in your email. If the link has expired, request a new one from the sign-in page. <a href="/">Go to sign in</a></div>
      ) : (
        <form onSubmit={save} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <Label text="New password"><input className="input" type="password" autoComplete="new-password" value={pw} onChange={e => setPw(e.target.value)} /></Label>
          <Label text="Repeat it"><input className="input" type="password" autoComplete="new-password" value={pw2} onChange={e => setPw2(e.target.value)} /></Label>
          <button className="btn btn-accent btn-block" disabled={busy} type="submit">{busy ? "Saving…" : "Save and sign in"}</button>
          <ErrorText>{err}</ErrorText>
        </form>
      )}
    </Shell>
  );
}
